import { ICommand, IDefineCommand, IQueryMediator, IQuery } from 'core-ts-types';
import { ITransferEquivalentCoursesDatasource } from '../datasources/transfer_equivalent_courses_datasource';
import { EquivalentCourse } from '../builders/equivalent_courses_builder';

angular.module('capability-ng-transfer').factory(
  'loadTransferMajorEquivalentCoursesCommand',
  (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngEquivalentCourseBuilder: any,
    ngTransferEquivalentCoursesDatasource: ITransferEquivalentCoursesDatasource,
    $http: ng.IHttpService
  ): ICommand => {
    return defineCommand('loadTransferMajorEquivalentCoursesCommand', function loadTransferMajorEquivalentCourses(
      deferred: ng.IDeferred<IQuery[]>,
      majorId: number,
    ): void {
      $http({
        method: 'GET',
        url: `student/program/${majorId}/equivalency/`
      })
        .then((response: ng.IHttpPromiseCallbackArg<any>): void => {
          const { results } = response.data
          deferred.resolve(new ngEquivalentCourseBuilder(results));
        })
        .catch(deferred.reject);
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/load_transfer_major_equivalent_courses_command.ts